import React from 'react'
import Header from '../component/layout/Header'
import Footer from '../component/layout/Footer'
import Blog from '../component/Blog/Blog.jsx'

const BlogPage = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when the page loads
  }, []);
  return (
    <>
    <Header activeLink={"blogs"}/>
    <Blog/>
    <Footer/>
    </>
  )
}

export default BlogPage